module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--2-61ee78fc.png";